// Pages/ViewBudgetMaster.jsx
import { useEffect, useState } from "react";
import { downloadAllAssetDataExcel } from "../../Api/AssetManagement";
import { Container, Table } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import { FaDownload } from "react-icons/fa";
import Logo from "../../Components/Logo";
import { useAssetContext } from '../../Context/MasterContext/AssetContext';

const AssignedAssetList = () => {
    const { assignedAsset,
        loadAssignedAsset, } = useAssetContext();
    const [loading, setLoading] = useState(false);

    const downloadAsssetExcelData = async () => {
        setLoading(true); // Show loader
        try {
            const response = await downloadAllAssetDataExcel(); // Call the API
            if (!response.data) {
                throw new Error("No data received from server");
            }
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Asset_Data.xlsx');

            // Trigger download
            document.body.appendChild(link);
            link.click();

            // Cleanup
            setTimeout(() => {
                window.URL.revokeObjectURL(url);
                link.parentNode.removeChild(link);
            }, 100);

        } catch (error) {
            console.error("Error downloading data:", error);
        } finally {
            setLoading(false); // Hide loader after API call
        }
    }

    console.log(assignedAsset, 'assignedAsset')

    useEffect(() => {
        loadAssignedAsset();
    }, []);

    return (
        <>
            <div className="main-content expand">
                <Container fluid className="list-container">
                    {loading && (
                        <div className="loading-overlay">
                            <Logo />
                        </div>
                    )}
                    <div className="page-headings">
                        <div className="heading-name">
                            <h2 className="list-title">Assigned Asset Lists</h2>
                        </div>
                        <div className="heading-options">
                            <button className="file-btn download-btn"
                                onClick={downloadAsssetExcelData}
                            >
                                <FaDownload className='file-icon' />
                            </button>
                        </div>
                    </div>

                    {assignedAsset.length > 0 ? (
                        <Table bordered hover responsive className="data-table">
                            <thead>
                                <tr>
                                    <th>Ser.</th>
                                    <th>Asset ID</th>
                                    <th>Assigned Name</th>
                                    <th>Effect Of</th>
                                    <th>Remarks</th>
                                    <th>Created At</th>
                                    <th>Created By</th>
                                </tr>
                            </thead>
                            <tbody>
                                {assignedAsset.map((budget, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{budget.Asset_ID}</td>
                                        <td>{budget.Assignee_ID} - {budget.Assignee_Name}</td>
                                        <td>{budget.withEffectOf}</td>

                                        <td>{budget.Remarks}</td>
                                        <td>{moment(budget.Created_Date).format('L')} at {budget.Created_Time}</td>
                                        <td>{budget.Created_By}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <p className="no-data">No Assets Data found.</p>
                    )}
                </Container>
            </div>
        </>
    );
};

export default AssignedAssetList